<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Business Accelerator' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/business_accelerator_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h4" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Introduction
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
                        When you have all the data at your disposal, you can then look for weaknesses and try to optimize them.
                        <br><br>
                        <h4 class="text-left font-weight-bold mb-2" >Running a successful online business is a constant optimization process.</h4> 
                        You need to constantly test different variations of the offer, hook, ad copy, creatives, audience as product stack, prices and see which one performs best, which one your audience likes.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Offer Optimizations
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
                        <h4 class="text-left font-weight-bold mb-2" >Copy</h4>
                        Test variations copy: longer copy vs short ( bullet point ) and see which one works best for your audience
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Price</h4>
                        Test price at least 4 times. A good rule of thumb is to establish a base price and then go very high and very low, then make tweaks to find a winner
                        Make sure to create a different page and split the traffic, but never split traffic on Facebook.
                        <br><br>
                        IMPORTANT: make sure to not send them to your customer list and remove pixels for retargeting; If some clients see them, be transparent: tell them you were testing prices, and give them the discount
                        You can also use software for split testing price, like VMO.
                        
                        <br><br>
                        <h4 class="text-left font-weight-bold mb-2" >Gifts</h4>
                        Add gifts to your offer or via upsells: Merch, free eBook, free course
                        <br><br>
                        For ecommerce, a good example is “Buy 2, get a free merch”
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Sales Page Optimizations
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2" >
                                                
                        <h4 class="text-left font-weight-bold mb-2" >Top Banner</h4>
                        Everything that’s above the fold should be tested multiple times.
                        Optimize and test multiple variations:
                        <br> - Headline + Subheadline
                        <br> - Headline + Video
                        <br> - Headline + Video + Subheadline
                        <br>
                        <br>
                        Optimize videos, even though it takes more time but it can have a significant improvement on your conversions
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Heatmap</h4>
                        Record with heatmap and analyze: See where drop offs are and add CTAs there to boost conversion
                        Never guess, always record, track and analyze
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >CRO Audits</h4>
                        Conduct CRO Audits - Ideally monthly or weekly after scalinganalyze
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Price</h4>
                        Price point test can go up to 20 tests
                        <br><br>
                        For physical products, a great trick is to add free shipping and increase the price. It's a phsycological thing, people are more likely to $25 product with free shipping than a $20 product with $5 shipping, even though the final amount is the same. 
                        <br><br>
                        Sometimes, increasing the free shipping quota will also increase the AOV. Changing the free shipping for order of $50 to orders of $75 will boost AOV as customers will be looking to spend more to get the free shipping
                        
                        <br><br>
                        <h4 class="text-left font-weight-bold mb-2" >Refund Guarantee</h4>
                        Test different guarantees that work for your audience, but always add a guarantee.
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Page Speed Load</h4>
                        Studies show that pages need to load in 3 seconds or less in order to double conversions against the normal slow sites that are often 6-10 seconds
                        <br><br>
                        That’s most important for mobile users, which lately takes the higher percentage of customers. For mobile users, their internet connection is not that fast as on desktops, and if the page takes too long to load, they will exit and never come back
                        <br><br>
                        Try to optimize your page speed so it loads in 2-3 seconds. A speed load of 5-6 seconds is acceptable but when you are ready to scale and are driving more traffic to that page, aim for 2-3 seconds.
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Live Chat</h4>
                        Adding live chat can help turn more visitors into leads or customers. Just make sure that there's someone that respondes in a timely manner, otherwise it can do more harm than good.
                        <br><br>
                        
                        <h4 class="text-left font-weight-bold mb-2" >Split test</h4>
                        ALWAYS RUN SPLIT TESTS!
                        
                        <br><br>
                        If all else fails, step back and optimize your offer. <br><br>
                        I know it’s hard to hear, but sometimes the offer sucks, so you need to go back at the beginning and re-adjust the offer: story, hook
                        If the offer sucks or is bad, it doesn’t matter how much you optimize your funnel and checkout page, because it’s still gonna fail or perform poorly
                        It’s like building a house on a bad foundation; if the foundation is poorly executed, the house will crumble. Same with the offer

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/business-accelerator/06.vue